'use strict';

function runScript(devConsole, appId, script, moduleFunc, storage, routerData) {
  if (devConsole.info) {
    devConsole.info('Loading the code for the ' + script.displayName + '. To debug this code, open ' + script.scriptName + ' in Developer Tools.');
  }

  self.$w = self.wix.getSelector(script.id, script.displayName);
  self.routerReturnedData = routerData;
  self['wix-storage'] = self.wix.getStorage(appId, storage);

  var module;
  try {
    module = moduleFunc();
  } catch (e) {
    devConsole.error('There was an error in your script');
    devConsole.error(e);
  }

  delete self.$w;
  delete self.routerReturnedData;
  delete self['wix-storage'];

  return module;
}

module.exports = {
  runScript
};



// WEBPACK FOOTER //
// ./src/main/worker/scriptRunner.js